import { useQueryParams } from "lib/hooks/useQueryParams";
import { useGetFirstPreference, useGetPreferences } from "api/preferences/useGetPreferences";
import { PAGE_SIZE, PUB_LANG } from "redux/slices/api/initialisePreferences";
import { getAggregations } from "./getAggregations";
import { getDates, getFrom, getQuery, getSize, getSort } from "./urlHelpers";
import { getAssetClassFilters, getTermFilters } from "./useGetFilters";

export const useCreateSearchRequest = (landingPageData) => {
  const qs = useQueryParams();
  const sizePref = useGetFirstPreference(PAGE_SIZE);
  const pubLangPref = useGetPreferences(PUB_LANG);

  try {
    const assetFilters = getAssetClassFilters(qs);
    const termFilters = getTermFilters(qs, pubLangPref);
    const defaultFilters = { ...assetFilters, ...termFilters };
    let landingPageFilters 
    if(termFilters.language && termFilters.language.length>0){
      landingPageFilters = { ...landingPageData?.reportFilter, language: termFilters.language } || {};
    }else{
       landingPageFilters = { ...landingPageData?.reportFilter} || {};
    }
    
    const finalFilters = landingPageData ? landingPageFilters : defaultFilters;

    const request = {
      query: getQuery(qs),
      filters: { ...finalFilters },
      dates: getDates(qs),
      aggregations: getAggregations(),
      size: getSize(qs, sizePref),
      from: getFrom(qs, sizePref),
      sort: getSort(qs),
    };

    return request;
  } catch (err) {
    console.error("Error creating search request:", err);
    return {};
  }
};
